module.exports = __webpack_public_path__ + "Roboto-Medium.2741a14e49524efa6059.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/roboto-fontface/fonts/Roboto/Roboto-Medium.woff2
// module id = 145
// module chunks = 10